import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { usePrefersReducedMotion } from '@hooks';

const StyledScrollButton = styled.button`
  position: fixed;
  bottom: 25px;
  right: 25px;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  color: var(--green);
  background-color: var(--light-navy);
  border: 1px solid var(--green);
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.45);

  opacity: ${props => (props.$visible ? '1' : '0')};
  visibility: ${props => (props.$visible ? 'visible' : 'hidden')};
  transform: translateY(${props => (props.$visible ? '0' : '12px')});
  transition: opacity 0.25s ease, transform 0.25s ease, visibility 0.25s ease,
    background-color 0.2s ease;

  &:hover,
  &:focus-visible {
    background-color: var(--green-tint);
    outline: none;
    transform: translateY(-3px);
  }

  svg {
    width: 20px;
    height: 20px;
  }

  /* Móvil: un poco más pequeño y pegado a la esquina, sin tapar contenido */
  @media (max-width: 768px) {
    bottom: 16px;
    right: 16px;
    width: 44px;
    height: 44px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: opacity 0.25s ease, visibility 0.25s ease;
    transform: none;
    &:hover,
    &:focus-visible {
      transform: none;
    }
  }
`;

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    const onScroll = () => {
      const scrolled = window.scrollY || window.pageYOffset;
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      // Visible tras pasar la mitad de la página.
      setVisible(scrollable > 0 && scrolled > scrollable / 2);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();

    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
  };

  return (
    <StyledScrollButton
      type="button"
      $visible={visible}
      onClick={scrollToTop}
      aria-label="Volver al principio"
      title="Volver al principio">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true">
        <line x1="12" y1="19" x2="12" y2="5" />
        <polyline points="5 12 12 5 19 12" />
      </svg>
    </StyledScrollButton>
  );
};

export default ScrollToTop;
